import React from 'react';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';
import rolesHelper from 'helpers/roles';

const ProviderIdFilter = <AutoCompleteFilter
    label='filters.components.providerId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        role_id: [
            rolesHelper.getProviderRoleId(),
        ],
        size: '12',
        sort_by: 'name',
        sort_direction: 'asc',
    } }
    reference='accounts'
    optionValue='id'
    searchBy='name'
    source='provider_id'
/>;

export default ProviderIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/ProviderIdFilter.js